/**
 * Normaliza teléfono para wa.me (Colombia: 10 dígitos que empiezan en 3 → +57).
 */
export function normalizePhoneForWhatsApp(phone) {
  const digits = String(phone || '').replace(/\D/g, '');
  if (!digits) return null;
  if (digits.length === 10 && digits.startsWith('3')) {
    return `57${digits}`;
  }
  if (digits.startsWith('57') && digits.length >= 12) {
    return digits;
  }
  if (digits.length >= 10) {
    return digits;
  }
  return null;
}

export function buildWhatsAppShareUrl(phone, message) {
  const normalized = normalizePhoneForWhatsApp(phone);
  if (!normalized) return null;
  return `https://wa.me/${normalized}?text=${encodeURIComponent(message)}`;
}

export function buildWhatsAppShareMessage(companyName, detailText) {
  const company = String(companyName || '').trim() || 'Mi Stock';
  return `Hola, desde ${company} ${detailText}`;
}

/**
 * Comparte documento: WhatsApp si hay teléfono, si no fallback nativo/portapapeles.
 */
export async function sharePublicDocument({
  phone,
  companyName,
  detailText,
  shareTitle,
  publicUrl,
  Swal,
}) {
  const message = buildWhatsAppShareMessage(companyName, detailText);
  const whatsappUrl = buildWhatsAppShareUrl(phone, message);

  if (whatsappUrl) {
    window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
    return;
  }

  if (navigator.share) {
    await navigator.share({
      title: shareTitle,
      text: detailText.split('\n')[0],
      url: publicUrl,
    });
    return;
  }

  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(publicUrl);
    await Swal.fire('Enlace copiado', 'Se copió el enlace público del PDF.', 'success');
    return;
  }

  await Swal.fire('Enlace público', publicUrl, 'info');
}
